import * as React from 'react';

const Zoom = ({
  fill = '#878B87',
  width = '22',
  height = '22'
}: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width + 'px'}
    height={height + 'px'}
    viewBox="0 0 22 22"
    version="1.1">
    <g
      id="Screens"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd">
      <g
        id="A---02-Product-Discovery---02-Product-Detail-(Frame)"
        transform="translate(-566.000000, -240.000000)"
        fill={fill}
        fillRule="nonzero">
        <g id="Image" transform="translate(0.000000, 223.000000)">
          <g id="zoom-in" transform="translate(566.000000, 17.000000)">
            <g id="Loupe">
              <path
                d="M10,0 C4.4771525,0 0,4.4771525 0,10 C0,15.5228475 4.4771525,20 10,20 C15.5228475,20 20,15.5228475 20,10 C20,4.4771525 15.5228475,0 10,0 Z M10,2 C14.418278,2 18,5.581722 18,10 C18,14.418278 14.418278,18 10,18 C5.581722,18 2,14.418278 2,10 C2,5.581722 5.581722,2 10,2 Z"
                id="Oval"
              />
              <path
                d="M15.6728932,15.6728932 C16.0333772,15.3124093 16.6006082,15.2846797 16.9928994,15.5897046 L17.0871068,15.6728932 L21.7071068,20.2928932 C22.0976311,20.6834175 22.0976311,21.3165825 21.7071068,21.7071068 C21.3466228,22.0675907 20.7793918,22.0953203 20.3871006,21.7902954 L20.2928932,21.7071068 L15.6728932,17.0871068 C15.2823689,16.6965825 15.2823689,16.0634175 15.6728932,15.6728932 Z"
                id="Path"
              />
            </g>
            <path
              d="M10,6 C10.5128358,6 10.9355072,6.38604019 10.9932723,6.88337887 L11,7 L11,13 C11,13.5522847 10.5522847,14 10,14 C9.48716416,14 9.06449284,13.6139598 9.00672773,13.1166211 L9,13 L9,7 C9,6.44771525 9.44771525,6 10,6 Z"
              id="Path"
            />
            <path
              d="M13,9 C13.5522847,9 14,9.44771525 14,10 C14,10.5128358 13.6139598,10.9355072 13.1166211,10.9932723 L13,11 L7,11 C6.44771525,11 6,10.5522847 6,10 C6,9.48716416 6.38604019,9.06449284 6.88337887,9.00672773 L7,9 L13,9 Z"
              id="Path"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Zoom;
